const OKTooltip = require('commons-components/build/OKTooltip');

module.exports = OKTooltip;
